class SignInDto {
  email!: string;

  password!: string;
}

export default SignInDto;
